import React from "react";

import type { AppShellHeaderContent } from "./AppShell.types";

interface AppShellContextValue {
  headerContent: AppShellHeaderContent;
  setHeaderContent: React.Dispatch<React.SetStateAction<AppShellHeaderContent>>;
}

export const EMPTY_APP_SHELL_HEADER: AppShellHeaderContent = {};

export const AppShellContext = React.createContext<AppShellContextValue | null>(
  null,
);

export const useAppShell = () => {
  const context = React.useContext(AppShellContext);

  if (!context) {
    throw new Error("useAppShell must be used within an AppShellLayout.");
  }

  return context;
};

export const useAppShellHeader = (headerContent: AppShellHeaderContent) => {
  const { setHeaderContent } = useAppShell();

  React.useEffect(() => {
    setHeaderContent(headerContent);

    return () => {
      setHeaderContent(EMPTY_APP_SHELL_HEADER);
    };
  }, [headerContent, setHeaderContent]);
};
